import { render, staticRenderFns } from "./contentUserSuspend.vue?vue&type=template&id=d08ad1fa&"
import script from "./contentUserSuspend.vue?vue&type=script&lang=js&"
export * from "./contentUserSuspend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports